<template>
    <div ref="printable">
        <h2 class="d-none d-print-block">Privacy Policy</h2>

        <p>
            <em>Effective date: October 03, 2019</em>
        </p>

        <p>
            Delta HCM LLC ("us", "we", or "our") operates the www.getmypaystub.com website and the GetMyPayStub App mobile application (hereinafter referred to as the "Service").
        </p>

        <p>
            This page informs you of our policies regarding the collection, use and disclosure of personal data when you use our Service and the choices you have associated with that data.
        </p>

        <p>
            We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.
        </p>


        <h3>Definitions</h3>

        <h4>Service</h4>
        <p>
            Service means the www.getmypaystub.com website and the GetMyPayStub App mobile application operated by Delta HCM LLC
        </p>

        <h4>Personal Data</h4>
        <p>
            Personal Data means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).
        </p>

        <h4>Usage Data</h4>
        <p>
            Usage Data is data collected automatically either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).
        </p>

        <h4>Cookies</h4>
        <p>
            Cookies are small files stored on your device (computer or mobile device).
        </p>


        <h3>Information Collection and Use</h3>
        <p>
            We collect several different types of information for various purposes to provide and improve our Service to you.
        </p>

        <h4>Types of Data Collected</h4>

        <h5>Personal Data</h5>
        <p>
            While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:
        </p>

        <ul>
            <li> Email address</li>
            <li> First name and last name</li>
            <li> Phone number</li>
            <li> Address, State, Province, ZIP/Postal code, City</li>
            <li> Cookies and Usage Data</li>
        </ul>

        <p>
            We may use your Personal Data to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or the instructions provided in any email we send.
        </p>

        <h5>Usage Data</h5>
        <p>
            We may also collect information that your browser sends whenever you visit our Service or when you access the Service by or through a mobile device ("Usage Data").
        </p>
        <p>
            This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
        </p>
        <p>
            When you access the Service with a mobile device, this Usage Data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.
        </p>

        <h5>Location Data</h5>
        <p>
            We may use and store information about your location if you give us permission to do so ("Location Data"). We use this data to provide features of our Service, to improve and customise our Service.
        </p>
        <p>
            You can enable or disable location services when you use our Service at any time by way of your device settings.
        </p>

        <h5>Tracking Cookies Data</h5>
        <p>
            We use cookies and similar tracking technologies to track the activity on our Service and we hold certain information.
        </p>
        <p>
            Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Other tracking technologies are also used such as beacons, tags and scripts to collect and track information and to improve and analyse our Service.
        </p>
        <p>
            You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.
        </p>

        <p>
            Examples of Cookies we use:
        </p>

        <ul>
            <li> Session Cookies. We use Session Cookies to operate our Service.</li>
            <li> Preference Cookies. We use Preference Cookies to remember your preferences and various settings.</li>
            <li> Security Cookies. We use Security Cookies for security purposes.</li>
        </ul>


        <h3>Use of Data</h3>
        <p>
            Delta HCM LLC uses the collected data for various purposes:
        </p>
        <ul>
            <li> To provide and maintain our Service</li>
            <li> To notify you about changes to our Service</li>
            <li> To allow you to participate in interactive features of our Service when you choose to do so</li>
            <li> To provide customer support</li>
            <li> To gather analysis or valuable information so that we can improve our Service</li>
            <li> To monitor the usage of our Service</li>
            <li> To detect, prevent and address technical issues</li>
            <li> To provide you with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information</li>
        </ul>

        <h3>Transfer of Data</h3>
        <p>
            Your information, including Personal Data, may be transferred to - and maintained on - computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.
        </p>
        <p>
            If you are located outside United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to United States and process it there.
        </p>
        <p>
            Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.
        </p>
        <p>
            Delta HCM LLC will take all the steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organisation or a country unless there are adequate controls in place including the security of your data and other personal information.
        </p>

        <h3>Disclosure of Data</h3>

        <h4>Business Transaction</h4>
        <p>
            If Delta HCM LLC is involved in a merger, acquisition or asset sale, your Personal Data may be transferred. We will provide notice before your Personal Data is transferred and becomes subject to a different Privacy Policy.
        </p>

        <h4>Disclosure for Law Enforcement</h4>
        <p>
            Under certain circumstances, Delta HCM LLC may be required to disclose your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).
        </p>

        <h4>Legal Requirements</h4>
        <p>
            Delta HCM LLC may disclose your Personal Data in the good faith belief that such action is necessary to:
        </p>
        <ul>
            <li> To comply with a legal obligation</li>
            <li> To protect and defend the rights or property of Delta HCM LLC</li>
            <li> To prevent or investigate possible wrongdoing in connection with the Service</li>
            <li> To protect the personal safety of users of the Service or the public</li>
            <li> To protect against legal liability</li>
        </ul>

        <h3>Security of Data</h3>
        <p>
            The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
        </p>

        <h3>Our Policy on "Do Not Track" Signals under the California Online Protection Act (CalOPPA)</h3>
        <p>
            We do not support Do Not Track ("DNT"). Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.
        </p>
        <p>
            You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.
        </p>

        <h3>Service Providers</h3>
        <p>
            We may employ third party companies and individuals to facilitate our Service ("Service Providers"), provide the Service on our behalf, perform Service-related services or assist us in analysing how our Service is used.
        </p>
        <p>
            These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
        </p>

        <h4>Analytics</h4>
        <p>
            We may use third-party Service Providers to monitor and analyse the use of our Service.
        </p>

        <h5>Google Analytics</h5>
        <p>
            Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our Service. This data is shared with other Google services. Google may use the collected data to contextualise and personalise the ads of its own advertising network. For more information on the privacy practices of Google, please visit the Google Privacy Terms web page: <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a>
        </p>

        <h3>Links to Other Sites</h3>
        <p>
            Our Service may contain links to other sites that are not operated by us. If you click a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.
        </p>
        <p>
            We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
        </p>

        <h3>Children's Privacy</h3>
        <p>
            Our Service does not address anyone under the age of 18 ("Children").
        </p>
        <p>
            We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.
        </p>

        <h3>Changes to This Privacy Policy</h3>
        <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
        </p>
        <p>
            We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the "effective date" at the top of this Privacy Policy.
        </p>
        <p>
            You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
        </p>


        <h3>Form 8850 Pre-Screening Notice and Certification Request for the Work Opportunity Credit</h3>
        <h3>OMB Control No. 1205-0371</h3>
        <p>
            Section 51(d)(13) permits a prospective employer to request the applicant to complete this form and give it to the prospective employer. The information will be used by the employer to complete the employer’s federal tax return. Completion of this form is voluntary and may assist members of targeted groups in securing employment COMPLETION OF THIS FORM IS VOLUNTARY AND MAY ASSIST MEMBERS OF TARGETED GROUPS IN SECURING EMPLOYMENT, WHICH YOU CONSENT TO COMPLETING THIS FORM. Routine uses of this form include giving it to the state workforce agency (SWA), which will contact appropriate sources to confirm that the applicant is a member of a targeted group. This form may also be given to the Internal Revenue Service for administration of the Internal Revenue laws, to the Department of Justice for civil and criminal litigation, to the Department of Labor for oversight of the certifications performed by the SWA, and to cities, states, and the District of Columbia for use in administering their tax laws. We may also disclose this information to other countries under a tax treaty, to federal and state agencies to enforce federal nontax criminal laws, or to federal law enforcement and intelligence agencies to combat terrorism.
        </p>

        <p>
            You are not required to provide the information requested on a form that is subject to the Paperwork Reduction Act unless the form displays a valid OMB control number. Books or records relating to a form or its instructions must be retained as long as their contents may become material in the administration of any Internal Revenue law. Generally, tax returns and return information are confidential, as required by section 6103.
        </p>

        <h3>Individual Characteristics Form (ICF) Work Opportunity Tax Credit</h3>
        <h3>OMB Control No. 1205-0371</h3>
        <p>
            Internal Revenue Code of 1986, Section 51, as amended and its enacting legislation, P.L. 104-188, specify that the State Workforce Agencies are the "designated" agencies responsible for administering the WOTC certification procedures of this program. The information you will provide by completing this form will be disclosed by your employer to the State Workforce Agency. ALTHOUGH PROVISION OF THIS INFORMATION IS VOLUNTARY, YOU CONSENT TO ACCURATELY PROVIDE THE INFORMATION REQUESTED. However, the information is required for your employer to receive the federal tax credit. IF THE INFORMATION YOU PROVIDE IS ABOUT A MEMBER OF YOUR FAMILY, YOU SHOULD PROVIDE HIM/HER A COPY OF THIS NOTICE.
        </p>

        <h3>Contact Us</h3>

        <p>
            If you have any questions about this Privacy Policy, please contact us:
        </p>

        <ul>
            <li> By email: <a href="mailto:privacy@getmypaystub.com">privacy@getmypaystub.com</a></li>
        </ul>

    </div>
</template>

<script>
import PrintableMixin from '@/mixins/Printable'

export default {
    mixins: [PrintableMixin],
    data() {
        return {
            'printableItemType': 'privacy-policy',
            'printableItemId': null,
            'printableStaticPDF': 'privacy-policy',
        }
    }
}
</script>
